import {
  Button,
  Card,
  Descriptions,
  Popconfirm,
  Tabs,
  message
} from 'antd'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { LocalDateTime } from '~/components/LocalDateTime'
import DoctorCourseStudents from './DoctorCourseStudents'
import { useCourseQuery } from './query'
import { useSyncServersMutation } from '../Admin/CourseDetails/CourseServers/mutation'
import { showErrors } from '~/utils/helpers'

const DoctorCourseDetails = () => {
  const { id } = useParams()
  const { data: course } = useCourseQuery(id)

  const software = useMemo(() => {
    if (!course || !course.software) {
      return ''
    }

    return course.software.name
  }, [course])

  const instructors = useMemo(() => {
    if (!course || !course.instructors) {
      return ''
    }

    return (
      <div>
        {course.instructors.map((instructor, index) =>
          index === 0 ? instructor.name : `, ${instructor.name}`
        )}
      </div>
    )
  }, [course])

  const casSupports = useMemo(() => {
    if (!course || !course.cas_supports) {
      return ''
    }

    return (
      <div>
        {course.cas_supports.map((casSupport, index) =>
          index === 0 ? casSupport.name : `, ${casSupport.name}`
        )}
      </div>
    )
  }, [course])

  const caseUploading = useMemo(() => {
    if (!course || !course.case_uploaders) {
      return ''
    }

    return (
      <div>
        {course.case_uploaders.map((uploader, index) =>
          index === 0 ? uploader.name : `, ${uploader.name}`
        )}
      </div>
    )
  }, [course])

  const syncServerMutation = useSyncServersMutation(Number(id))

  if (course == null) {
    return null
  }

  return (
    <>
      <PageHeader
        className='radup-page-header'
        title={course?.name}
        onBack={() => window.history.back()}
        extra={[
          <Popconfirm
            key='sync_servers'
            title={
              'Do you want to request to sync the servers after updating data on the master server?'
            }
            okText='YES'
            onConfirm={() => {
              syncServerMutation.mutate(Number(id), {
                onSuccess: () => {
                  message.success(
                    'Request to start syncing server successfully'
                  )
                },
                onError: showErrors
              })
            }}
          >
            {course.sync_servers_enabled && !course.is_ended && (
              <Button type='primary'>Sync servers</Button>
            )}
          </Popconfirm>
        ]}
      />
      <Card title='Event Info'>
        <Descriptions>
          <Descriptions.Item label='Software'>{software}</Descriptions.Item>
          <Descriptions.Item label='Instructors'>
            {instructors}
          </Descriptions.Item>
          <Descriptions.Item label='CAS supports'>
            {casSupports}
          </Descriptions.Item>
          <Descriptions.Item label='Case-uploading'>
            {caseUploading}
          </Descriptions.Item>
          <Descriptions.Item label='Start date'>
            <LocalDateTime
              date={course?.start_at}
              timezone={course?.timezone}
            />
          </Descriptions.Item>
          <Descriptions.Item label='End date'>
            <LocalDateTime date={course?.end_at} timezone={course?.timezone} />
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card>
        <Tabs
          defaultActiveKey='1'
          items={[
            {
              key: '1',
              label: 'Workstations',
              children: <DoctorCourseStudents />
            }
          ]}
        />
      </Card>
    </>
  )
}

export default DoctorCourseDetails
